// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__TjuzS","rtl":"Carousel_rtl__PZkFz"};